interface SpinnerProps {
  label?: string;
  className?: string;
}

export function Spinner({ label = 'Loading…', className = '' }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={`flex items-center justify-center gap-3 text-neutral-400 ${className}`}
    >
      <div className="h-5 w-5 rounded-full border-2 border-surface-500 border-t-lime-500 animate-spin" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
